module.exports = __webpack_public_path__ + "img/folder-do.ab92431d.svg";